const isCssVariable = (value) => Boolean(value.match(/^var\(([a-z-0-9,\s]+)\)$/));

export default isCssVariable;
